import { render } from "./MyprofileIcon.vue?vue&type=template&id=6231ac3b&scoped=true"
import script from "./MyprofileIcon.vue?vue&type=script&lang=js"
export * from "./MyprofileIcon.vue?vue&type=script&lang=js"

import "./MyprofileIcon.vue?vue&type=style&index=0&id=6231ac3b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6231ac3b"]])

export default __exports__